import { GridApi, IRowNode } from "ag-grid-community";

// Parse a container height ("300px" or 300) into a usable pixel number.
// "100%" and anything non-numeric are rejected - a detail row cannot use them.
function returnHeightAsPixels(heightPx: string | number | undefined): number {
  if (heightPx == undefined) return NaN;
  if (typeof heightPx == "number") return heightPx;
  if (!heightPx.endsWith("px")) return NaN;
  return parseFloat(heightPx);
}

/**
 * AG Grid watches the theme class on the grid root and resets every row height when it
 * changes, which sends `detailRowAutoHeight` rows back to their 1px seed. Auto-height
 * only recovers on a ResizeObserver hit, which never comes for a detail whose own
 * container height did not move - so the expanded row stays collapsed. Re-assert the
 * height the detail already knows. Deferred so it lands after AG Grid's own reset.
 */
export function reapplyDetailRowHeight(
  node: IRowNode | undefined,
  api: GridApi | undefined,
  heightPx: string | number | undefined,
): () => void {
  const height = returnHeightAsPixels(heightPx);
  if (!node || !api || !isFinite(height) || height <= 0) return () => {};

  const timer = window.setTimeout(() => {
    if (api.isDestroyed()) return;
    node.setRowHeight(height);
    api.onRowHeightChanged();
  }, 0);

  return () => window.clearTimeout(timer);
}
